export default {
	name: 'workshopPage',
	title: 'Workshop Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Title',
			type: 'string',
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'slug',
			title: 'Slug',
			type: 'slug',
			options: {
				source: 'title',
				maxLength: 96,
			},
			validation: (Rule) => Rule.required(),
		},
		{
			name: 'description',
			title: 'Description (Short)',
			Description: 'Short description of the workshop',
			type: 'text',
		},
		{
			name: 'content',
			title: 'Workshop Content (Long Description)',
			description:
				'Full description of the workshop with rich text. Use shift+enter for line breaks.',

			type: 'array',
			of: [
				{ type: 'block' },
				{
					type: 'image',
					options: { hotspot: true },
				},
			],
		},
		{
			name: 'date',
			title: 'Date & Start time',
			type: 'datetime',
			description:
				'This will be used to extract day, month, year and time information',
		},
		{
			name: 'time',
			title: 'Display Time',
			type: 'string',
			description: 'E.g., "10:00 AM - 12:00 PM"',
		},
		{
			name: 'duration',
			title: 'Duration (Hours)',
			type: 'number',
		},
		{
			name: 'location',
			title: 'Location',
			type: 'string',
		},
		{
			name: 'variant',
			title: 'Visual Variant',
			type: 'string',
			options: {
				list: [
					{ title: 'Light', value: 'light' },
					{ title: 'Dark', value: 'dark' },
				],
			},
			initialValue: 'light',
		},
		{
			name: 'isVirtual',
			title: 'Virtual Workshop',
			type: 'boolean',
		},
		{
			name: 'price',
			title: 'Price',
			type: 'string',
			description: 'E.g., "R350" or "Free"',
		},
		{
			name: 'ifFree',
			title: 'Free Entry',
			type: 'boolean',
		},
		{
			name: 'limit',
			title: 'Limit',
			type: 'number',
			description: 'Number of available seats (0 means fully booked)',
		},
		{
			name: 'image',
			title: 'Image',
			type: 'image',
			options: {
				hotspot: true,
			},
		},
		{
			name: 'calendarIconUrl',
			title: 'Calendar Icon URL',
			type: 'url',
		},
		{
			name: 'webinarLink',
			title: 'Webinar Link (Zoom/Google Meet Link)',
			type: 'url',
		},
		{
			name: 'isFeatured',
			title: 'Is Featured',
			type: 'boolean',
			initialValue: false,
		},

		{
			name: 'benefits',
			title: 'Benefits',
			type: 'array',
			of: [{ type: 'string' }],
			description: 'List of benefits for workshop attendees',
		},
	],
	preview: {
		select: {
			title: 'title',
			media: 'image',
			date: 'date',
			limit: 'limit',
		},
		prepare({ title, media, date, limit }) {
			const status =
				limit === 0 ? 'Fully Booked' : limit ? `${limit} seats left` : '';
			const dateString = date
				? new Date(date).toLocaleDateString()
				: 'No date set';

			return {
				title,
				media,
				subtitle: `${dateString}${status ? ` • ${status}` : ''}`,
			};
		},
	},
};
